// extracted by mini-css-extract-plugin
export default {"title":"p22gw","section":"ZffXd","btn-container":"Q5wj5","card-wrap":"Whr8j","flex-wrap":"RnduG","button":"f0W8i"};